import { CurrencyResponse } from '../types';

export function setCurrency(currency: CurrencyResponse) {
    return {
        type: 'SET_CURRENCY',
        payload: currency,
    };
}
